import React, { startTransition, useEffect, useState } from "react";
import axios from "axios";
import { baseurl } from "../constant";
import { useNavigate } from "react-router-dom";

import OwlCarousel from "react-owl-carousel";

const Login = () => {
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [login, setlogin] = useState();
  const [error, seterror] = useState();
  const [usernamerr, setusernameerr] = useState();
  const [passworderr, setpassworderr] = useState();
  const [errorMessages, setErrorMessages] = useState({});
  const [status, setstatus] = useState();

  const options = {
    items: 1,
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    dots: false,
    animateOut: "fadeOut",
    animateIn: "fadeIn",
  };

  const navigate = useNavigate();

  const onliginclick = async () => {
    setlogin();
    setstatus();
  };
  const handellogin = async (req, res) => {
    try {
      const login = await axios.post(baseurl + "loginAuth", {
        username: username,
        password: password,
      });
      setstatus(login.data.status);
      setlogin(login.data.message);
      if (login.data.status === "1") {
        const token = await login.data.token;

        // localStorage.setItem("token", await login.data.token, 10);
        const now = new Date();
        const expiryTime = now.getTime() + 1 * 60 * 1000; // 1 minute = 60,000 milliseconds
        const tokenData = {
          token,
          expiry: expiryTime,
        };

        localStorage.setItem("authToken", tokenData.token);
        navigate("/dashboard", { state: { token1: token } });
      } else {
      }
    } catch (err) {
      seterror("err");
    }
  };
  return (
    <>
      {error ? (
        <div>
          <h3>network error api not working</h3>
        </div>
      ) : (
        <body className="defult-login">
          <input type="hidden" id="siteUrl" value="https://www.payol.in/" />
          <div className="login_header_section">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-3 col-md-3">
                  <div className="Login_logo">
                    <a href="https://www.payol.in/">
                      <img
                        src="accets\img\677363070.png"
                        className="img-fluid"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="login_top_Details">
                    <ul>
                      <li>
                        <span>Helpline Number:</span>{" "}
                        <i className="fa fa-phone"></i>
                        <a href="tel:0123456789" target="_blank">
                          +91-0123456789
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-envelope"></i>
                        <a href="mailto:example@gmail.com" target="_blank">
                          example@gmail.com
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3">
                  <div className="login_social">
                    <ul className="top-social-icon-2">
                      <li>
                        <a href="javascript:void(0);">
                          <i className="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="fa fa-linkedin"></i>
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="fa fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="login_section_mt">
            <div className="container">
              <div className="row">
                <div className="col-lg-7 col-md-6">
                  <div className=" aon-bnr1-carousal">
                    <OwlCarousel className="owl-theme" {...options}>
                      <div className="item">
                        <div className="login_lIMG">
                          <img
                            src="accets/img/login1.png"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                      <div className="item">
                        <div className="login_lIMG">
                          <img
                            src="accets/img/login2.png"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                      <div className="item">
                        <div className="login_lIMG">
                          <img
                            src="accets/img/login3.png"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                    </OwlCarousel>
                  </div>
                </div>
                <div className="col-lg-5 col-md-6">
                  <div className="login_logo">
                    <a href="https://www.payol.in/">
                      <img src="accets/img/677363070.png" />
                    </a>
                  </div>
                  <div className="login_colm-frm help_u_forms">
                    <div className="loginform_head">
                      {status == 0 && (
                        <div class="alert alert-danger alert-dismissable">
                          <button
                            type="button"
                            class="close"
                            data-dismiss="alert"
                            aria-hidden="true"
                            onClick={() => setstatus()}
                          >
                            ×
                          </button>
                          {login.split("\n").map((item, indx) => (
                            <p style={{ color: "red" }}>{item}</p>
                          ))}
                        </div>
                      )}
                      <h3> Login</h3>
                      <h5>to Continue</h5>
                    </div>

                    <div className="login_colm-frm_col">
                      <form
                        action="#"
                        accept-charset="utf-8"
                        onSubmit={(e) => {
                          e.preventDefault();
                          handellogin();
                        }}
                      >
                        <div className="form-group">
                          <i className="fa fa-user"></i>
                          <input
                            className="form-control"
                            name="username"
                            value={username}
                            type="text"
                            placeholder="User ID"
                            onClick={() => {
                              onliginclick();
                            }}
                            onChange={(e) => {
                              setUserName(e.target.value);
                            }}
                            required
                          />
                        </div>
                        {/* {!username && <h1>username is required</h1>} */}
                        <div className="form-group">
                          <i className="fa fa-lock"></i>
                          <input
                            className="form-control"
                            name="password"
                            value={password}
                            type="password"
                            placeholder="Password"
                            onClick={() => onliginclick()}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                          />
                        </div>
                        {/* <div>
                          <p style={{ color: "red" }}>{login}</p>
                        </div> */}
                        {/* <div className="form-group">
                          <div className="row">
                            <div className="col-sm-6">
                              <a className="forgot_password_icon">
                                Forgot Password
                              </a>
                            </div>
                            <div className="col-sm-6">
                              <a
                                // href="https://www.payol.in/forgot/tPin"
                                className="forgot_password_icon"
                              >
                                Forgot T-PIN
                              </a>
                            </div>
                          </div>
                        </div> */}
                        <div className="form-group text-center">
                          <button
                            className="btn_submit"
                            type="submit"
                            // onClick={() => handellogin()}
                            onKeyDown={(e) =>
                              e.key === "Enter" ? handellogin : ""
                            }
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {""}
          <div className="login_footer">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="aon-foo-copyright-2 text-center">
                    © 2023 Payol Digital Technologies Private Limited. All Right
                    Reserved |{" "}
                    <a href="https://www.payol.in/about">About Payol</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </body>
      )}
    </>
  );
};

export default Login;
